import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {base64ToFile, ImageCroppedEvent} from 'ngx-image-cropper';
import {Photo} from '../admin/pages/pages-api.service';

@Component({
    selector: 'app-upload-image',
    templateUrl: './image-upload.component.html',
    standalone: false
})
export class ImageUploadComponent implements OnInit {
  @Input() current?: Photo;
  @Output() imageUploaded = new EventEmitter<Photo>();

  imageChangedEvent: any = '';
  imageUrl = '';
  croppedImage: any = '';
  croppedFile: Blob;
  isEditing = false;

  constructor(private http: HttpClient) {}
  ngOnInit() {}

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.imageUrl = '';
    this.isEditing = true;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedFile = base64ToFile(event.base64);
  }
  imageLoaded(image: any) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  loadUrl(photo: Photo) {
    if (photo) {
      this.imageUrl = `rest-api/v1/community/photos/upload/${photo.id}`;
      this.imageChangedEvent = '';
      this.isEditing = true;
    }
  }

  save() {
    const formData = new FormData();
    formData.append('photo', this.croppedFile);

    this.http.post<Photo>('rest-api/v1/community/photos/upload', formData).subscribe(photo => {
      this.imageUploaded.emit(photo);
      this.isEditing = false;
    });
  }

  discard() {
    this.imageChangedEvent = '';
    this.imageUrl = '';
    this.isEditing = false;
    // this.imageUploaded.emit(this.current);
  }
}
